module.exports = __webpack_public_path__ + "62c629e1f9964658a9106bc518369870.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/greetings/swing.png
// module id = 3414
// module chunks = 0